(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(header) {
      if (!header || header.dataset.tbInit === '1') return;
      header.dataset.tbInit = '1';

      var toggle = header.querySelector('[data-tb-toggle]');
      var drawerId = toggle && toggle.getAttribute('aria-controls');
      var drawer = drawerId ? document.getElementById(drawerId) : null;
      if (!toggle || !drawer) return;

      if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }

      var savedScrollY = 0;

      function openDrawer() {
        savedScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.style.top = '-' + savedScrollY + 'px';
        document.body.classList.add('tb-no-scroll');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Menü schließen');
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Menü öffnen');
        document.body.classList.remove('tb-no-scroll');
        document.body.style.top = '';
        window.scrollTo(0, savedScrollY);
      }

      toggle.addEventListener('click', function () {
        drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
      });

      drawer.querySelectorAll('[data-tb-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });

      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setTimeout(closeDrawer, 120);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });

      if (header.classList.contains('tb-header--sticky')) {
        var onScroll = function () {
          if (window.scrollY > 8) header.classList.add('is-scrolled');
          else header.classList.remove('is-scrolled');
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      var mql = window.matchMedia('(min-width: 1025px)');
      var handleMql = function (e) {
        if (e.matches && drawer.classList.contains('is-open')) closeDrawer();
      };
      if (mql.addEventListener) mql.addEventListener('change', handleMql);
      else mql.addListener(handleMql);
    }

    function initAll() {
      document.querySelectorAll('[data-tb-header]').forEach(initHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var header = e.target.querySelector('[data-tb-header]');
      if (header) initHeader(header);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var sectionId = e.detail && e.detail.sectionId;
      if (sectionId) {
        var orphan = document.getElementById('tb-drawer-' + sectionId);
        if (orphan && orphan.parentElement === document.body) orphan.remove();
      }
      document.body.classList.remove('tb-no-scroll');
      document.body.style.top = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousels(section) {
      var carousels = section.querySelectorAll('[data-carousel]');
      carousels.forEach(function (carousel) {
        if (carousel.dataset.carouselInit === '1') return;
        carousel.dataset.carouselInit = '1';

        var grid    = carousel.querySelector('[data-grid]');
        var prevBtn = carousel.querySelector('[data-arrow="prev"]');
        var nextBtn = carousel.querySelector('[data-arrow="next"]');
        if (!grid) return;

        function updateState() {
          var hasOverflow = grid.scrollWidth > grid.clientWidth + 1;
          carousel.classList.toggle('has-overflow', hasOverflow);

          if (prevBtn) prevBtn.disabled = grid.scrollLeft <= 1;
          if (nextBtn) nextBtn.disabled = (grid.scrollLeft + grid.clientWidth) >= (grid.scrollWidth - 1);
        }

        function scrollByPage(dir) {
          var step = grid.clientWidth;
          // Slight reduction so a card stays visible as anchor
          var card = grid.querySelector('.shop-card');
          if (card) {
            var cardWidth = card.getBoundingClientRect().width;
            step = Math.max(cardWidth, step - cardWidth * 0.2);
          }
          grid.scrollBy({ left: dir * step, behavior: 'smooth' });
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); });

        grid.addEventListener('scroll', updateState, { passive: true });

        // ============ Drag-to-scroll (desktop mouse drag) ============
        var isDown = false;
        var startX = 0;
        var startScroll = 0;
        var dragMoved = false;

        grid.addEventListener('mousedown', function (e) {
          // Ignore right-click and middle-click
          if (e.button !== 0) return;
          isDown = true;
          dragMoved = false;
          startX = e.pageX - grid.offsetLeft;
          startScroll = grid.scrollLeft;
          // Don't add is-dragging class yet — wait until actual movement
        });

        window.addEventListener('mouseup', function () {
          if (!isDown) return;
          isDown = false;
          grid.classList.remove('is-dragging');
        });

        grid.addEventListener('mouseleave', function () {
          if (!isDown) return;
          isDown = false;
          grid.classList.remove('is-dragging');
        });

        grid.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          var x = e.pageX - grid.offsetLeft;
          var walk = x - startX;
          if (Math.abs(walk) > 5 && !dragMoved) {
            dragMoved = true;
            grid.classList.add('is-dragging');
          }
          if (dragMoved) {
            e.preventDefault();
            grid.scrollLeft = startScroll - walk;
          }
        });

        // Prevent click after drag (so clicking a card link doesn't fire mid-drag)
        grid.addEventListener('click', function (e) {
          if (dragMoved) {
            e.preventDefault();
            e.stopPropagation();
            dragMoved = false;
          }
        }, true);

        // Initial + after layout settles
        updateState();
        requestAnimationFrame(updateState);
        setTimeout(updateState, 100);

        // Resize observer (more reliable than just window.resize)
        if (typeof ResizeObserver !== 'undefined') {
          var ro = new ResizeObserver(updateState);
          ro.observe(grid);
        } else {
          window.addEventListener('resize', updateState);
        }
      });
    }

    function initShop(section) {
      if (!section || section.dataset.shopInit === '1') {
        // Even if shop init is done, re-init carousels (panels can be added/changed)
        initCarousels(section);
        return;
      }
      section.dataset.shopInit = '1';

      var tabs = section.querySelectorAll('[data-tab]');
      var panels = section.querySelectorAll('[data-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
          });
          // Re-evaluate carousels after panel switch (visibility changes)
          requestAnimationFrame(function () { initCarousels(section); });
        });
      });

      initCarousels(section);
    }

    function initAll() {
      document.querySelectorAll('[data-shop]').forEach(initShop);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-shop]');
      if (section) initShop(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-final-cta"] && !Shopify.designMode) return;
  try {
    
  class CtaAnchorScroll extends HTMLElement {
    connectedCallback() {
      const trigger = this.querySelector('a[href^="#"]');
      if (!trigger) return;
      trigger.addEventListener('click', (event) => this.#scrollToTarget(event, trigger));
    }

    #scrollToTarget(event, trigger) {
      const id = trigger.getAttribute('href').slice(1);
      if (!id) return;

      const target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

      const focusable = target.querySelector('input, select, textarea, button, a[href]');
      if (focusable) {
        window.setTimeout(() => focusable.focus({ preventScroll: true }), reduced ? 0 : 600);
      }
    }
  }

  if (!customElements.get('cta-anchor-scroll')) {
    customElements.define('cta-anchor-scroll', CtaAnchorScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-options"] && !Shopify.designMode) return;
  try {
    
  class AnchorScrollLinks extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => this.#onClick(event));
    }

    #onClick(event) {
      const trigger = event.target.closest('a[href^="#"]');
      if (!trigger || !this.contains(trigger)) return;

      const id = trigger.getAttribute('href').slice(1);
      if (!id) return;

      const target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

      const field = target.querySelector('input, select, textarea');
      if (field) {
        window.setTimeout(() => field.focus({ preventScroll: true }), reduced ? 0 : 600);
      }
    }
  }

  if (!customElements.get('anchor-scroll-links')) {
    customElements.define('anchor-scroll-links', AnchorScrollLinks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corporate-gifting-hero"] && !Shopify.designMode) return;
  try {
    
  class GiftingLeadForm extends HTMLElement {
    #form;
    #status;
    #submit;
    #submitLabel;
    #leadPublished = false;

    connectedCallback() {
      this.#form = this.querySelector('form');
      if (!this.#form) return;

      this.#status = this.querySelector('[data-lead-status]');
      this.#submit = this.querySelector('[data-lead-submit]');
      this.#submitLabel = this.#submit ? this.#submit.textContent : '';

      if (this.dataset.mode === 'endpoint') {
        this.#form.addEventListener('submit', (event) => this.#sendToEndpoint(event));
      } else {
        this.#form.addEventListener('submit', () => this.#composeBody());
        this.#handlePostedState();
      }

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.#form.reset();
      });
    }

    /**
     * Nach dem Absenden raeumt Shopify die URL nicht auf: die Query-Parameter
     * bleiben stehen, sodass die Erfolgsmeldung bei jedem Neuladen erneut
     * erscheint. Wir zeigen sie einmal, leeren die Felder und saeubern die URL,
     * damit ein Reload die Seite im Ausgangszustand zeigt.
     */
    #handlePostedState() {
      const posted = this.querySelector('[data-lead-posted]');
      const message = this.querySelector('[data-lead-status]');

      if (message) {
        message.scrollIntoView({ block: 'center' });
        message.focus({ preventScroll: true });
      }

      if (!posted) return;

      this.#trackLeadSubmit();

      this.#form.reset();
      this.#cleanUrl();
      this.#redirect();
    }

    #trackLeadSubmit() {
      if (this.#leadPublished) return;
      window.dataLayer = window.dataLayer || [];

      window.gtag = window.gtag || function() {
        window.dataLayer.push(arguments);
      };

      window.gtag('event', 'b2b_lead_submit', {
        send_to: 'G-1K4YNWYLKH',
        lead_type: 'corporate_gifting',
        page_path: window.location.pathname
      });
      this.#leadPublished = true;
    }


    /**
     * Leitet auf die Danke-Seite weiter. Im Modus "Meldung, dann weiterleiten"
     * bleibt die Erfolgsmeldung fuer die eingestellte Dauer sichtbar.
     */
    #redirect() {
      const url = this.dataset.redirect;
      if (!url) return;

      const delay = parseInt(this.dataset.redirectDelay, 10) || 0;

      if (delay <= 0) {
        window.location.replace(url);
        return;
      }

      window.setTimeout(() => window.location.assign(url), delay);
    }

    #cleanUrl() {
      if (!window.history || !window.history.replaceState) return;

      const url = new URL(window.location.href);
      let changed = false;

      for (const key of [...url.searchParams.keys()]) {
        if (key === 'contact_posted' || key === 'form_type' || key === 'utf8' || key.startsWith('contact[')) {
          url.searchParams.delete(key);
          changed = true;
        }
      }

      if (!changed) return;

      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    #fieldEntries() {
      const entries = [];
      for (const field of this.#form.querySelectorAll('[data-lead-field]')) {
        entries.push({
          key: field.dataset.leadKey || field.name,
          label: field.dataset.leadLabel || field.name,
          value: field.value.trim()
        });
      }
      return entries;
    }

    #composeBody() {
      const body = this.querySelector('[data-lead-body]');
      if (!body) return;

      const parts = [];
      if (this.dataset.subject) parts.push(this.dataset.subject);
      if (this.dataset.recipient) parts.push('Zustellung an: ' + this.dataset.recipient);

      for (const entry of this.#fieldEntries()) {
        if (entry.value) parts.push(entry.label + ': ' + entry.value);
      }

      body.value = parts.join('\n');
    }

    async #sendToEndpoint(event) {
      event.preventDefault();

      if (!this.#form.reportValidity()) return;

      const endpoint = this.dataset.endpoint;
      if (!endpoint) {
        console.error('Lead form: Versandart "Eigener Endpoint" ist aktiv, aber es ist keine Endpoint-URL hinterlegt.');
        this.#showStatus('error', 'Das Formular ist noch nicht fertig eingerichtet (Endpoint-URL fehlt).');
        return;
      }

      const payload = {
        recipient: this.dataset.recipient || '',
        subject: this.dataset.subject || '',
        page: window.location.href
      };

      const lines = [];
      for (const entry of this.#fieldEntries()) {
        payload[entry.key] = entry.value;
        if (entry.value) lines.push(entry.label + ': ' + entry.value);
      }
      payload.message = lines.join('\n');
      payload._replyto = payload.email || '';

      this.#setBusy(true);

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) throw new Error('Request failed with status ' + response.status);

        this.#form.reset();
        this.#showStatus('success', this.dataset.success);

        this.#redirect();
      } catch (error) {
        console.error('Lead form submission failed:', error);
        this.#showStatus('error', this.dataset.error);
      } finally {
        this.#setBusy(false);
      }
    }

    #setBusy(busy) {
      if (!this.#submit) return;
      this.#submit.disabled = busy;
      this.#submit.textContent = busy ? '…' : this.#submitLabel;
    }

    #showStatus(type, message) {
      if (!this.#status) return;

      this.#status.textContent = message || '';
      this.#status.hidden = false;
      this.#status.classList.toggle('cg-hero__message--success', type === 'success');
      this.#status.classList.toggle('cg-hero__message--error', type === 'error');
      this.#status.setAttribute('role', type === 'success' ? 'status' : 'alert');
      this.#status.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('gifting-lead-form')) {
    customElements.define('gifting-lead-form', GiftingLeadForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-logo-button"] && !Shopify.designMode) return;
  try {
    
  class MiniHeader extends HTMLElement {
    #onScroll;

    connectedCallback() {
      this.#bindAnchor();
      this.#bindShadow();
    }

    disconnectedCallback() {
      if (this.#onScroll) window.removeEventListener('scroll', this.#onScroll);
    }

    #bindAnchor() {
      const trigger = this.querySelector('a[href^="#"]');
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        const id = trigger.getAttribute('href').slice(1);
        if (!id) return;

        const target = document.getElementById(id);
        if (!target) return;

        event.preventDefault();

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

        const field = target.querySelector('input, select, textarea');
        if (field) {
          window.setTimeout(() => field.focus({ preventScroll: true }), reduced ? 0 : 600);
        }
      });
    }

    #bindShadow() {
      if (this.dataset.shadow !== 'true' || !this.classList.contains('cg-head--sticky')) return;

      this.#onScroll = () => {
        this.classList.toggle('cg-head--scrolled', window.scrollY > 8);
      };

      this.#onScroll();
      window.addEventListener('scroll', this.#onScroll, { passive: true });
    }
  }

  if (!customElements.get('mini-header')) {
    customElements.define('mini-header', MiniHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-scroller')) {
    class PsScroller extends HTMLElement {
      #ac = null;
      #ro = null;
      #track = null;
      #prev = null;
      #next = null;
      #raf = 0;
      #settleTimer = 0;
      #suppressClick = false;
      #drag = { active: false, moved: false, startX: 0, startScroll: 0 };

      connectedCallback() {
        this.#ac = new AbortController();
        const { signal } = this.#ac;

        this.#track = this.querySelector('[data-ps-track]');
        this.#prev = this.querySelector('[data-ps-prev]');
        this.#next = this.querySelector('[data-ps-next]');
        if (!this.#track) return;

        this.#prev?.addEventListener('click', () => this.#step(-1), { signal });
        this.#next?.addEventListener('click', () => this.#step(1), { signal });
        this.#track.addEventListener('scroll', () => this.#queueUpdate(), { signal, passive: true });
        this.#track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
        this.#track.addEventListener('keydown', (event) => this.#onKey(event), { signal });

        if (this.dataset.drag === 'true') this.#bindDrag(signal);

        this.#ro = new ResizeObserver(() => this.#queueUpdate());
        this.#ro.observe(this.#track);
        for (const item of this.#track.children) this.#ro.observe(item);

        this.#update();
      }

      disconnectedCallback() {
        this.#ac?.abort();
        this.#ro?.disconnect();
        cancelAnimationFrame(this.#raf);
        clearTimeout(this.#settleTimer);
      }

      /** @returns {ScrollBehavior} */
      #behavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      /** @returns {number} width of one card incl. gap */
      #unit() {
        const item = this.#track.querySelector('[data-ps-item]');
        if (!item) return this.#track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.#track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      /** @param {number} dir -1 | 1 */
      #step(dir) {
        const unit = this.#unit();
        const visible = Math.max(1, Math.floor((this.#track.clientWidth + 1) / unit));
        const distance = this.dataset.scrollBy === 'page' ? unit * visible : unit;
        const rtl = getComputedStyle(this.#track).direction === 'rtl' ? -1 : 1;
        this.#track.scrollBy({ left: dir * distance * rtl, behavior: this.#behavior() });
      }

      /** @param {KeyboardEvent} event */
      #onKey(event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.#step(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.#step(-1);
        }
      }

      #queueUpdate() {
        if (this.#raf) return;
        this.#raf = requestAnimationFrame(() => {
          this.#raf = 0;
          this.#update();
        });
      }

      #update() {
        const track = this.#track;
        const max = track.scrollWidth - track.clientWidth;
        const pos = Math.abs(track.scrollLeft);
        const overflow = max > 1;
        this.toggleAttribute('data-overflow', overflow);
        if (this.#prev) this.#prev.disabled = !overflow || pos <= 1;
        if (this.#next) this.#next.disabled = !overflow || pos >= max - 1;
      }

      /** @param {AbortSignal} signal */
      #bindDrag(signal) {
        const track = this.#track;
        track.addEventListener('pointerdown', (event) => this.#onDown(event), { signal });
        track.addEventListener('pointermove', (event) => this.#onMove(event), { signal });
        track.addEventListener('pointerup', (event) => this.#onUp(event), { signal });
        track.addEventListener('pointercancel', (event) => this.#onUp(event), { signal });
        track.addEventListener('click', (event) => this.#onClick(event), { signal, capture: true });
      }

      /** @param {PointerEvent} event */
      #onDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        const track = this.#track;
        if (track.scrollWidth - track.clientWidth <= 1) return;
        this.#suppressClick = false;
        clearTimeout(this.#settleTimer);
        this.#drag = { active: true, moved: false, startX: event.clientX, startScroll: track.scrollLeft };
        track.classList.add('is-dragging');
      }

      /** @param {PointerEvent} event */
      #onMove(event) {
        if (!this.#drag.active) return;
        const dx = event.clientX - this.#drag.startX;
        if (!this.#drag.moved) {
          if (Math.abs(dx) < 5) return;
          this.#drag.moved = true;
          this.#track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.#track.scrollLeft = this.#drag.startScroll - dx;
      }

      /** @param {PointerEvent} event */
      #onUp(event) {
        if (!this.#drag.active) return;
        const track = this.#track;
        const { moved } = this.#drag;
        this.#drag.active = false;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        if (!moved) {
          track.classList.remove('is-dragging');
          return;
        }
        this.#suppressClick = true;
        setTimeout(() => {
          this.#suppressClick = false;
        }, 0);
        this.#settle();
      }

      /** @param {MouseEvent} event */
      #onClick(event) {
        if (!this.#suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.#suppressClick = false;
      }

      #settle() {
        const track = this.#track;
        const finish = () => {
          clearTimeout(this.#settleTimer);
          track.classList.remove('is-dragging');
        };
        if (this.dataset.snap !== 'true') {
          finish();
          return;
        }
        const pad = parseFloat(getComputedStyle(track).scrollPaddingInlineStart) || 0;
        const pos = track.scrollLeft;
        const maxPos = track.scrollWidth - track.clientWidth;
        let target = null;
        let best = Infinity;
        for (const item of track.querySelectorAll('[data-ps-item]')) {
          const left = Math.min(item.offsetLeft - pad, maxPos);
          const diff = Math.abs(left - pos);
          if (diff < best) {
            best = diff;
            target = left;
          }
        }
        if (target === null || best < 1) {
          finish();
          return;
        }
        track.addEventListener('scrollend', finish, { once: true, signal: this.#ac.signal });
        this.#settleTimer = setTimeout(finish, 700);
        track.scrollTo({ left: target, behavior: this.#behavior() });
      }
    }

    customElements.define('ps-scroller', PsScroller);
  }

  } catch(e) { console.error(e); }
})();
})();
